import { getFinancingCardColumns } from "./FinancingCard.config";

import FinancingCard from "./FinancingCard";

const FinancingCardContainer = ({ items }: any) => {
  const columns = getFinancingCardColumns();

  return <FinancingCard items={items} columns={columns} />;
};

export default FinancingCardContainer;
